import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';

import { EntityInformationView } from './EntityInformationView';

export const EntityInformationSection = () => {
  const { account } = useAccountSelector();

  return (
    <MFormSection title='Entity Information' isEditable={false} isEditMode={false} testId='entity-information'>
      <EntityInformationView entityInformation={account?.entityInformation} />
    </MFormSection>
  );
};
